package link.erpango.quip.data.db

import link.erpango.quip.data.db.entities.AuthDAO
import link.erpango.quip.data.db.entities.MaintenanceDAO
import link.erpango.quip.data.db.entities.SparePartDAO
import link.erpango.quip.data.db.entities.UserDAO
import link.erpango.quip.data.db.entities.VehiclesDAO
import link.erpango.quip.data.db.entities.CommonValuesDAO
import link.erpango.quip.data.db.entities.VehicleDocumentDAO
import link.erpango.quip.data.db.entities.SparePartDocumentDAO
import link.erpango.quip.data.db.entities.CatalogDAO
import link.erpango.quip.QuipConstants
import link.erpango.quip.db.QuipDb

class DbDataSource(
    private val db: QuipDb
): IDbDataSource {
    override val auth = AuthDAO(db)
    override val user = UserDAO(db)
    override val garage = VehiclesDAO(db)
    override val maintenance = MaintenanceDAO(db)
    override val sparePart = SparePartDAO(db)
    override val commonValues = CommonValuesDAO(db)
    override val vehicleDocuments = VehicleDocumentDAO(db)
    override val sparePartDocuments = SparePartDocumentDAO(db)
    override val catalog = CatalogDAO(db)
    
    /**
     * Borra todos los datos locales de la base de datos.
     * El orden es importante debido a las foreign keys:
     * 1. Primero las tablas de relación (maintenance_spare_parts)
     * 2. Luego las tablas dependientes (spare_part, maintenance)
     * 3. Finalmente las tablas principales (vehicle, user, auth)
     */
    override suspend fun deleteAllData() {
        // 1. Borrar relaciones maintenance-spare_parts
        db.maintenanceSparePartsQueries.delete_all()
        
        // 1.5. Borrar documents
        db.vehicleDocumentQueries.deleteAll()
        db.sparePartDocumentQueries.deleteAll()
        
        // 2. Borrar spare parts
        db.sparePartQueries.delete_all()
        
        // 3. Borrar maintenances
        db.maintenanceQueries.delete_all()
        
        // 4. Borrar vehicles
        db.garageQueries.delete_all()
        
        // 5. Borrar user
        db.userQueries.deleteAll()
        
        // 6. Borrar auth tokens
        db.authQueries.deleteAll()

        // 7. Borrar catálogo de vehículos (modelos antes que marcas por FK)
        db.vehicleCatalogQueries.deleteAllModels()
        db.vehicleCatalogQueries.deleteAllBrands()

        // 8. El consentimiento para enviar notas al LLM es de cada cuenta
        db.commonValuesQueries.deleteValue(QuipConstants.CommonValues.NoteImport.aiConsent)
    }
}